import React from "react";
import { TableRow, TableCell } from "@mui/material";
import CeldaMotivoContinuidad from "./cells/CeldaMotivoContinuidad";
import CeldaCedula from "./cells/CeldaCedula";
import CeldaAlmacen from "./cells/CeldaAlmacen";
import CeldaEstado from "./cells/CeldaEstado";
import CeldaEntregaProducto from "./cells/CeldaEntregaProducto";
import CeldaResultado from "./cells/CeldaResultado";
import CeldaDetalles from "./cells/CeldaDetalles";
import CeldaIdentificador from "./cells/CeldaIdentificador";
import CeldaDigital from "./cells/CeldaDigital";
import CeldaInfo from "./cells/CeldaInfo";
import CeldaSolicitudes from "./cells/CeldaSolicitudes";
import CeldaDocumental from "./cells/CeldaDocumental";
import CeldaTelefonica from "./cells/CeldaTelefonica";
import CeldaDomicilio from "./cells/CeldaDomicilio";
import CeldaLaboral from "./cells/CeldaLaboral";
import CeldaAnalista from "./cells/CeldaAnalista";
import CeldaOperador from "./cells/CeldaOperador";
import CeldaInformeOperador from "./cells/CeldaInformeOperador";
import { puedeFirmarDigital } from "./ListadoSolicitud.utils";

// Una fila de la tabla de ListadoSolicitud.js. Cada celda compleja vive en su
// propio componente bajo ./cells/ (mismo JSX y lógica que tenía aquí mismo
// antes de dividirse, solo reubicado); las celdas triviales de una sola línea
// (N° Solicitud, Cliente, Fecha, Vendedor, Tipo de Cliente) se quedan inline.
export default function SolicitudTableRow({
  data,
  index,
  analistas,
  operadores,
  popoverData,
  clienteEstados,
  setIsOpenMotivo,
  setDataInforme,
  setCurrentAction,
  setCurrentData,
  setOpenDialog2,
  setIsOpenPdf,
  handleOpenObservacionCredito,
  handlePopoverOpen,
  handlePopoverClose,
  handleOpenCambioBodega,
  handleOpenDialog,
  handleOpenFirmaElectronica,
  handleOpenAuditoriaIntegral,
  handlesolicitud,
  handledocumentos,
  handleTelefonica,
  handleOpenModalVerificacion,
  handleOpenDialogDomicilioLaboral,
  handleEditarAnalista,
  handleEditarOperador,
  permisosFila,
  estaDeshabilitado,
  verificacionSolicitud,
}) {
  const {
    permisoAgregarObservacionCredito,
    permisoCambiarBodega,
    permisoAprobarEstado,
    tienePermisoEditarAnalista,
    permisoEditarOperador,
    estadoDeshabilitadoporPermisos,
    estadoDeshabilitadoDocumental,
    estadoDeshabilitadotelefonica,
    permisoEditarVerificacionTerreno,
    permisoReasignarDomicilio,
    permisoReasignarLaboral,
    puedeDescargarDocumentosBS,
  } = permisosFila;

  const puedeFirmar = puedeFirmarDigital(data);
  const isError = (data.Estado === 4 || data.Estado === 5 || data.Estado === 7);
  const isReprocesoRow = data.Estado === 10;
  // Data grid de alta densidad: filas al ras (sin gaps/tarjetas flotantes),
  // tipografía compacta (11px) y colores de alerta en tonos pastel (rose/
  // orange) en vez de rojos saturados — menos fatiga visual en listados largos.
  const bgColor = isError
    ? "#fff1f2" // rose-50
    : isReprocesoRow
      ? "#fff7ed" // orange-50
      : index % 2 === 0
        ? "#ffffff"
        : "#f8fafc"; // slate-50
  const hoverColor = isError ? "#ffe4e6" /* rose-100 */ : isReprocesoRow ? "#ffedd5" /* orange-100 */ : "#f1f5f9" /* slate-100 */;
  const borderColor = isError ? "#ffe4e6" : isReprocesoRow ? "#ffedd5" : "#f1f5f9";
  const textColor = isError ? "#881337" /* rose-900 */ : isReprocesoRow ? "#9a3412" /* orange-800 */ : "#1e293b" /* slate-800 */;
  return (
    <TableRow
      sx={{
        backgroundColor: bgColor,
        transition: "background-color 0.15s ease",
        "&:hover": {
          backgroundColor: hoverColor,
        },
        "& td": {
          borderBottom: "1px solid",
          borderColor,
          padding: "6px 8px",
          fontSize: "0.6875rem", // 11px
          color: textColor,
        },
        cursor: "pointer",
      }}
    >
      <CeldaMotivoContinuidad
        data={data}
        setIsOpenMotivo={setIsOpenMotivo}
        setDataInforme={setDataInforme}
      />

      <TableCell align="center">
        {data.NumeroSolicitud}
      </TableCell>
      <TableCell align="center">{data.nombre}</TableCell>

      <CeldaCedula
        data={data}
        permisoAgregarObservacionCredito={permisoAgregarObservacionCredito}
        handleOpenObservacionCredito={handleOpenObservacionCredito}
        handlePopoverOpen={handlePopoverOpen}
        popoverData={popoverData}
        handlePopoverClose={handlePopoverClose}
        clienteEstados={clienteEstados}
      />

      <TableCell align="center">
        {new Date(data.fecha).toLocaleString()}
      </TableCell>

      <CeldaAlmacen
        data={data}
        permisoCambiarBodega={permisoCambiarBodega}
        handleOpenCambioBodega={handleOpenCambioBodega}
      />

      <TableCell align="center">{data.vendedor}</TableCell>

      <CeldaEstado
        data={data}
        permisoAprobarEstado={permisoAprobarEstado}
        setCurrentAction={setCurrentAction}
        setCurrentData={setCurrentData}
        setOpenDialog2={setOpenDialog2}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaEntregaProducto data={data} />

      {/* Tipo de Cliente */}
      <TableCell align="center">{data.tipoCliente}</TableCell>

      <CeldaResultado data={data} handlePopoverOpen={handlePopoverOpen} />

      <CeldaDetalles data={data} isError={isError} handleOpenDialog={handleOpenDialog} />

      <CeldaIdentificador data={data} />

      <CeldaDigital
        data={data}
        puedeFirmar={puedeFirmar}
        puedeDescargarDocumentosBS={puedeDescargarDocumentosBS}
        handleOpenFirmaElectronica={handleOpenFirmaElectronica}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaInfo data={data} isError={isError} handleOpenAuditoriaIntegral={handleOpenAuditoriaIntegral} />

      <CeldaSolicitudes
        data={data}
        isError={isError}
        estaDeshabilitado={estaDeshabilitado}
        estadoDeshabilitadoporPermisos={estadoDeshabilitadoporPermisos}
        handlesolicitud={handlesolicitud}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaDocumental
        data={data}
        isError={isError}
        estaDeshabilitado={estaDeshabilitado}
        estadoDeshabilitadoDocumental={estadoDeshabilitadoDocumental}
        verificacionSolicitud={verificacionSolicitud}
        handledocumentos={handledocumentos}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaTelefonica
        data={data}
        isError={isError}
        estaDeshabilitado={estaDeshabilitado}
        verificacionSolicitud={verificacionSolicitud}
        estadoDeshabilitadotelefonica={estadoDeshabilitadotelefonica}
        handleTelefonica={handleTelefonica}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaDomicilio
        data={data}
        isError={isError}
        verificacionSolicitud={verificacionSolicitud}
        permisoEditarVerificacionTerreno={permisoEditarVerificacionTerreno}
        permisoReasignarDomicilio={permisoReasignarDomicilio}
        handleOpenModalVerificacion={handleOpenModalVerificacion}
        handleOpenDialogDomicilioLaboral={handleOpenDialogDomicilioLaboral}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaLaboral
        data={data}
        isError={isError}
        verificacionSolicitud={verificacionSolicitud}
        permisoEditarVerificacionTerreno={permisoEditarVerificacionTerreno}
        permisoReasignarLaboral={permisoReasignarLaboral}
        handleOpenModalVerificacion={handleOpenModalVerificacion}
        handleOpenDialogDomicilioLaboral={handleOpenDialogDomicilioLaboral}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaAnalista
        data={data}
        analistas={analistas}
        tienePermisoEditarAnalista={tienePermisoEditarAnalista}
        handleEditarAnalista={handleEditarAnalista}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaOperador
        data={data}
        operadores={operadores}
        permisoEditarOperador={permisoEditarOperador}
        handleEditarOperador={handleEditarOperador}
        handlePopoverOpen={handlePopoverOpen}
      />

      <CeldaInformeOperador data={data} setIsOpenPdf={setIsOpenPdf} setDataInforme={setDataInforme} />
    </TableRow>
  );
}
